import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './sections/Home';
import Projects from './sections/Projects';
import AIProjects from './sections/AIProjects';
import Experience from './sections/Experience';
import Certifications from './sections/Certifications';
import Skills from './sections/Skills';
import Contact from './sections/Contact';
import Footer from './components/Footer';
import AIProjectDetail from './pages/AIProjectDetail';
import './App.css';

function MainPage() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
    localStorage.setItem('theme', 'light');
  }, []);

  useEffect(() => {
    let animationFrameId;
    let position = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    let targetPosition = { x: window.innerWidth / 2, y: window.innerHeight / 2 };

    const handleMouseMove = (e) => {
      targetPosition.x = e.clientX;
      targetPosition.y = e.clientY;
    };

    const animate = () => {
      position.x += (targetPosition.x - position.x) * 0.15;
      position.y += (targetPosition.y - position.y) * 0.15;
      setMousePosition({ x: position.x, y: position.y });
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();
    window.addEventListener('mousemove', handleMouseMove, { passive: true });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove, { passive: true });
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div className="App">
      <div
        className="cursor-glow"
        style={{ left: `${mousePosition.x}px`, top: `${mousePosition.y}px` }}
      />
      <Navbar />
      <main>
        <Home />
        <Projects />
        <AIProjects />
        <Experience />
        <Certifications />
        <Skills />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/ai-projects/:id" element={<AIProjectDetail />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
